const DIAGNOSIS_URL = 'https://products-eight-sand.vercel.app/';

const checkItems = [
  '評価基準が曖昧で、評価が属人化している',
  '評価結果に社員の納得感がない',
  '優秀な人材が定着しない',
  '人事制度を5年以上更新していない',
  '人材育成が現場任せになっている',
  '人事制度が経営戦略と連動していない',
];

export default function HeroSection() {
  return (
    <section
      className="relative flex items-center pt-16"
      style={{
        minHeight: '75vh',
        fontFamily: "'Noto Sans JP', sans-serif",
      }}
    >
      {/* 背景画像 */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/7d3f3fa6280bf4f12fa6e316822a692d.jpg"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        {/* グラデーションオーバーレイ */}
        <div
          className="absolute inset-0"
          style={{
            background:
              'linear-gradient(120deg, rgba(13,43,85,0.88) 0%, rgba(26,74,142,0.80) 50%, rgba(13,43,85,0.75) 100%)',
          }}
        ></div>
      </div>

      {/* 装飾グロー */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full opacity-10"
          style={{
            background:
              'radial-gradient(circle, #2D8EFF 0%, transparent 70%)',
          }}
        ></div>
        <div
          className="absolute bottom-1/4 right-1/4 w-64 h-64 rounded-full opacity-10"
          style={{
            background:
              'radial-gradient(circle, #7ECBFF 0%, transparent 70%)',
          }}
        ></div>
      </div>

      <div className="relative max-w-[1080px] mx-auto px-6 py-20 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Text Content */}
          <div className="flex flex-col gap-6">
            <h1 className="text-3xl lg:text-[44px] font-bold text-white leading-tight tracking-tight">
              最短15分で、貴社の<br />
              人事制度の
              <span style={{ color: '#7ECBFF' }}>課題を可視化</span>
              する。
            </h1>

            <p className="text-white/80 text-base lg:text-lg leading-relaxed font-light">
              「なんとなくの評価」が優秀な人材を失わせています。<br />
              KT Partnersが学術理論×実務知見で人事制度の現状を<br className="hidden lg:block" />
              客観的に診断し、改善の道筋を示します。
            </p>

            <div className="flex flex-col gap-3 mt-2">
              <a
                href={DIAGNOSIS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-[#2D8EFF] text-white text-base font-medium px-8 py-4 rounded-lg cursor-pointer whitespace-nowrap transition-all hover:bg-[#1A5CB0]"
                style={{ boxShadow: '0 4px 20px rgba(45,142,255,0.40)' }}
              >
                <i className="ri-play-circle-line text-lg"></i>
                今すぐ無料トライアルを受ける
              </a>
              <a
                href="#flow"
                className="inline-flex items-center justify-center gap-2 border border-white/50 text-white text-base font-medium px-8 py-4 rounded-lg cursor-pointer whitespace-nowrap transition-all hover:bg-white/10"
              >
                <i className="ri-arrow-down-line text-lg"></i>
                診断の流れを見る
              </a>
            </div>
          </div>

          {/* Right: Checklist Card */}
          <div
            className="bg-white rounded-xl p-7"
            style={{ boxShadow: '0 8px 40px rgba(13,43,85,0.25)' }}
          >
            <div className="flex items-center gap-3 mb-5">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-amber-50 flex-shrink-0">
                <i className="ri-alert-fill text-amber-500 text-lg"></i>
              </div>
              <h2 className="text-[#1A1A2E] text-xl font-bold">
                こんな症状はありませんか？
              </h2>
            </div>

            <ul className="flex flex-col gap-3.5 mb-5">
              {checkItems.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="w-6 h-6 rounded-full bg-[#EEF4FB] flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-[#2D8EFF] text-sm"></i>
                  </span>
                  <span className="text-[#1A1A2E] text-xl leading-snug">
                    {item}
                  </span>
                </li>
              ))}
            </ul>

            <div className="bg-[#EEF4FB] border border-[#D0DCF0] rounded-lg px-4 py-3.5">
              <p className="text-[#1A5CB0] text-xl font-medium text-center">
                2つ以上当てはまる<br />
                <strong>→制度の見直しが必要です</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
